import {
  GetManagementDocument,
  useUpdateManagementAsAdminMutation,
} from "../../../lib/apollo/graphql/generated";
import BasicButton from "../../common/components/BasicButton";
import BoxWithShadow from "../../common/components/BoxWithShadow";
import LabeledInput from "../../common/components/LabeledInput";
import { SharedCompanyInfoSectionProps } from "../container/CompanyInfoContainer";

export default function CompanyInfoForm({
  form,
  onChange,
}: SharedCompanyInfoSectionProps) {
  const [updateInfo, { loading: isUpdating }] =
    useUpdateManagementAsAdminMutation({
      onCompleted: () => {
        alert("정보를 수정했습니다");
      },
      refetchQueries: [
        {
          query: GetManagementDocument,
        },
      ],
    });

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    updateInfo({
      variables: {
        managementInput: form,
      },
    });
  };

  return (
    <BoxWithShadow className="h-full min-h-[800px]">
      <form onSubmit={onSubmit} className="flex h-full flex-col gap-5">
        <div className="flex gap-1">
          <LabeledInput
            label="회사명"
            placeholder="회사명"
            value={form.companyName}
            onValueChange={(value) => onChange("companyName", value)}
          />
          <LabeledInput
            label="대표자명"
            placeholder="대표자명"
            value={form.ceoName}
            onValueChange={(value) => onChange("ceoName", value.trim())}
          />
        </div>
        <LabeledInput
          label="카피라이트"
          placeholder="카피라이트"
          value={form.copyright}
          onValueChange={(value) => onChange("copyright", value)}
        />
        <LabeledInput
          label="주소"
          placeholder="주소"
          value={form.address}
          onValueChange={(value) => onChange("address", value)}
        />
        <div className="flex gap-1">
          <LabeledInput
            label="전화번호"
            placeholder="전화번호"
            value={form.phone}
            onValueChange={(value) => onChange("phone", value)}
          />
          <LabeledInput
            label="이메일"
            placeholder="이메일"
            value={form.email}
            onValueChange={(value) => onChange("email", value)}
          />
        </div>
        <div className="flex gap-1">
          <LabeledInput
            label="사업자등록번호"
            placeholder="사업자등록번호"
            value={form.registrationNumber}
            onValueChange={(value) => onChange("registrationNumber", value)}
          />
          <LabeledInput
            label="통신판매업 등록번호"
            placeholder="통신판매업 등록번호"
            value={form.escroRegistration}
            onValueChange={(value) => onChange("escroRegistration", value)}
          />
        </div>
        <div className="flex gap-1">
          <LabeledInput
            label="카카오 채널 주소"
            placeholder="카카오 채널 주소"
            value={form.kakaoAddress}
            onValueChange={(value) => onChange("kakaoAddress", value)}
          />
          <LabeledInput
            label="쇼핑몰 주소"
            placeholder="쇼핑몰 주소"
            value={form.shopAddress}
            onValueChange={(value) => onChange("shopAddress", value)}
          />
        </div>
        <div className="flex gap-1">
          <LabeledInput
            type="number"
            inputMode="numeric"
            label="친구초대 포인트"
            placeholder="친구초대 포인트"
            value={form.invitationPoint}
            onValueChange={(value) => onChange("invitationPoint", +value)}
          />
          <LabeledInput
            type="number"
            inputMode="numeric"
            label="팁 최소금액"
            placeholder="팁 최소금액"
            value={form.minimumTip}
            onValueChange={(value) => onChange("minimumTip", +value)}
          />
        </div>
        <BasicButton
          type="submit"
          text="정보 수정"
          className="mt-auto w-2/3 self-center"
          loading={isUpdating}
          disabled={isUpdating}
        />
      </form>
    </BoxWithShadow>
  );
}
